/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type SuspendClusterOrgAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class SuspendClusterOrgAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: SuspendClusterOrgAuthClusterResponse429ResponseBodyData;

  constructor(
    err: SuspendClusterOrgAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "SuspendClusterOrgAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type SuspendClusterOrgAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class SuspendClusterOrgAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: SuspendClusterOrgAuthClusterResponse409ResponseBodyData;

  constructor(
    err: SuspendClusterOrgAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "SuspendClusterOrgAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type SuspendClusterOrgAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class SuspendClusterOrgAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: SuspendClusterOrgAuthClusterResponse404ResponseBodyData;

  constructor(
    err: SuspendClusterOrgAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "SuspendClusterOrgAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type SuspendClusterOrgAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class SuspendClusterOrgAuthClusterResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: SuspendClusterOrgAuthClusterResponseResponseBodyData;

  constructor(
    err: SuspendClusterOrgAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "SuspendClusterOrgAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type SuspendClusterOrgAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class SuspendClusterOrgAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: SuspendClusterOrgAuthClusterResponseBodyData;

  constructor(
    err: SuspendClusterOrgAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "SuspendClusterOrgAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type SuspendClusterOrgResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class SuspendClusterOrgResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: SuspendClusterOrgResponseBodyData;

  constructor(
    err: SuspendClusterOrgResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "SuspendClusterOrgResponseBody";
  }
}

/** @internal */
export const SuspendClusterOrgAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new SuspendClusterOrgAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type SuspendClusterOrgAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const SuspendClusterOrgAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    SuspendClusterOrgAuthClusterResponse429ResponseBody
  > = z.instanceof(SuspendClusterOrgAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const SuspendClusterOrgAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new SuspendClusterOrgAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type SuspendClusterOrgAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const SuspendClusterOrgAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    SuspendClusterOrgAuthClusterResponse409ResponseBody
  > = z.instanceof(SuspendClusterOrgAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const SuspendClusterOrgAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new SuspendClusterOrgAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type SuspendClusterOrgAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const SuspendClusterOrgAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    SuspendClusterOrgAuthClusterResponse404ResponseBody
  > = z.instanceof(SuspendClusterOrgAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const SuspendClusterOrgAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new SuspendClusterOrgAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type SuspendClusterOrgAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const SuspendClusterOrgAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    SuspendClusterOrgAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    SuspendClusterOrgAuthClusterResponseResponseBody
  > = z.instanceof(SuspendClusterOrgAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const SuspendClusterOrgAuthClusterResponseBody$inboundSchema: z.ZodType<
  SuspendClusterOrgAuthClusterResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new SuspendClusterOrgAuthClusterResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type SuspendClusterOrgAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const SuspendClusterOrgAuthClusterResponseBody$outboundSchema: z.ZodType<
  SuspendClusterOrgAuthClusterResponseBody$Outbound,
  z.ZodTypeDef,
  SuspendClusterOrgAuthClusterResponseBody
> = z.instanceof(SuspendClusterOrgAuthClusterResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const SuspendClusterOrgResponseBody$inboundSchema: z.ZodType<
  SuspendClusterOrgResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new SuspendClusterOrgResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type SuspendClusterOrgResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const SuspendClusterOrgResponseBody$outboundSchema: z.ZodType<
  SuspendClusterOrgResponseBody$Outbound,
  z.ZodTypeDef,
  SuspendClusterOrgResponseBody
> = z.instanceof(SuspendClusterOrgResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
